import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import validator from 'validator'
import { isAfter, parse, isValid } from 'date-fns'

localize('ja', ja)

// 全ルールをimport
for (let rule in rules) {
  extend(rule, {
    ...rules[rule]
  })
}

extend('phonenumber', {
  validate: value => {
    return /^\d{9,11}$/.test(value)
  },
  message: '{_field_}はハイフンなしの数字9~11桁で入力してください'
})

extend('required_checkbox', {
  ...rules['required'],
  message: '確認してチェックしてください'
})

extend('password', {
  validate: (value) => {
    return value.length >= 8
  },
  message: 'パスワードは8文字以上で入力してください'
})

extend('credit_card', {
  validate: (value) => {
    return validator.isCreditCard(value)
  },
  message: '{_field_}はハイフンなしの半角数字で入力してください',
})

extend('kana', {
  validate: (value) => {
    const regexp = new RegExp('^[ぁ-んー　]+$')
    return regexp.test(value)
  },
  message: '{_field_}はひらがなで入力してください'
})

extend('credit_card_expiration_date', {
  validate: (value) => {
    try {
      const valueDate = parse(value, 'MM/yy', new Date())
      return isAfter(valueDate, new Date())
    } catch (e) {
      return false
    } 
  },
  message: '{_field_}は月/年の形式で入力してください'
})

extend('valid_date', {
  validate: value => {
    const d = new Date(value)
    return isValid(d)
  },
  message: '{_field_}が正しく入力できているかご確認ください'
})

extend('valid_time', {
  validate: value => {
    const isValidFormat = /(\d{2}):(\d{2})/.test(value)
    if (!isValidFormat) return false
    const time = value.split(':')
    const hour = parseInt(time[0])
    const minute = parseInt(time[1])
    return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59
  },
  message: '時間は半角の数字でHH:mmのフォーマットで入力してください'
})

extend('before_date', {
  params: ['target'],
  validate: (value, { target }) => {
    return value <= target
  },
  message: '開始日は終了日以前の日にちを入力してください'
})

extend('after_date', {
  params: ['target'],
  validate: (value, { target }) => {
    return value >= target
  },
  message: '終了日は開始日以降の日にちを入力してください'
})

extend('activity_before_date', {
  params: ['target'],
  validate: (value, { target }) => {
    return value <= target
  },
  message: '活動日時はノートの終了日以前の日にちを入力してください'
})

extend('activity_after_date', {
  params: ['target'],
  validate: (value, { target }) => {
    return value >= target
  },
  message: '活動日時はノートの開始日以降の日にちを入力してください'
})

extend('before_time', {
  params: ['target'],
  validate: (value, { target }) => {
    const targetNum = +target.split(':').join('').padEnd(6, '0')
    const valueNum = +value.split(':').join('').padEnd(6, '0')
    return valueNum < targetNum
  },
  message: '開始時間は終了時間以前を入力してください'
})

extend('after_time', {
  params: ['target'],
  validate: (value, { target }) => {
    const targetNum = +target.split(':').join('').padEnd(6, '0')
    const valueNum = +value.split(':').join('').padEnd(6, '0')
    return valueNum > targetNum
  },
  message: '終了時間は開始時間以降を入力してください'
})

extend('hankaku_number', {
  ...rules['numeric'],
  message: '{_field_}は半角の数字を入力してください'
})

// ファイルがURLで与えられている場合はこのバリデーションは使えないので注意。
extend('file_size', {
  validate: (value) => {
    // ファイルがURLで与えられている場合はバリデーションを通すように
    if (!(value instanceof File)) {
      return true
    }
    const MB = 2 ** 20
    return value.size < 5 * MB
  },
  message: '5MB以上のサイズのファイルはアップロードできません',
})

const install = (Vue) => {
  Vue.component('ValidationProvider', ValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)
}
export default {
  install
}
